import CustomCanvasLayerIcon from '@mui/icons-material/CropOriginal';

import CustomCanvasPriceList from './CustomCanvasPriceList';

import EditCustomCanvasSizePrice from './EditCustomCanvasSizePrice';
import CreateCustomCanvasSizePrice from './CreateCustomCanvasSizePrice';

export default {
      create: CreateCustomCanvasSizePrice,
      list: CustomCanvasPriceList,
      edit: EditCustomCanvasSizePrice,
      icon: CustomCanvasLayerIcon,
}